var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({left:_vm.leftNum+'px'}),attrs:{"id":"breadcrumbs"}},[_vm._v("\n  当前位置："),_c('span',{staticClass:"path"},[_vm._v(_vm._s(_vm.meta.bt))])])
}
var staticRenderFns = []

export { render, staticRenderFns }